import axios from "axios";
import { getToken } from "../Utils/UpdateUsersState";

const getIdle = async (to, from) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}idle`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: { to, from },
    });
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

export { getIdle };
